import { getReviewStatisticsApi } from '../config';

export const {
  getReviewStatisticsActions,
  getReviewStatistics,
  getReviewStatisticsSuccess,
  getReviewStatisticsError,
  getReviewStatisticsClear,
} = getReviewStatisticsApi;
